import { parseEndpointOrigin } from "@quovy/control-plane-contract";

export type EndpointPairValue = { webOrigin: string; apiOrigin: string };

/**
 * Endpoint configuration is optional, but it is atomic when present. Keeping
 * this rule outside the form component lets registration share the same
 * client-side contract as the operator console without importing that app.
 */
export function endpointPairValid(value: EndpointPairValue): boolean {
  const empty = !value.webOrigin && !value.apiOrigin;
  return (
    empty ||
    (parseEndpointOrigin(value.webOrigin) !== null && parseEndpointOrigin(value.apiOrigin) !== null)
  );
}
